import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { PuroSettingObject } from '@libs/types/src/services/object-type/puro-setting.object';
import { PuroSettingUpsertInput } from '@libs/types/src/services/input-type/puro-setting.upsert-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { PmupSettingObject } from '@libs/types/src/services/object-type/pmup-setting.object';
import { PmupSettingUpsertInput } from '@libs/types/src/services/input-type/pmup-setting.upsert-input';

@Injectable({ providedIn: 'root' })
export class SystemGqlService extends GqlServiceV2 {

    public async getPuroSetting(input: IdInput, fragment: string) {
        return this.query<PuroSettingObject>(
            `
                query ($input: IdInput!) {
                    puroSetting {
                        currentOrLatest(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async upsertPuroSettings(input: PuroSettingUpsertInput, fragment: string) {
        return this.query<PuroSettingObject>(
            `
                mutation ($input: PuroSettingUpsertInput!) {
                    puroSetting {
                        upsert(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getPmupSetting(input: IdInput, fragment: string) {
        return this.query<PmupSettingObject>(
            `
                query ($input: IdInput!) {
                    pmupSetting {
                        currentOrLatest(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async upsertPmupSettings(input: PmupSettingUpsertInput, fragment: string) {
        return this.query<PmupSettingObject>(
            `
                mutation ($input: PmupSettingUpsertInput!) {
                    pmupSetting {
                        upsert(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
